import { render, staticRenderFns } from "./AccountRecovery.vue?vue&type=template&id=bddae8e4&scoped=true"
import script from "./AccountRecovery.vue?vue&type=script&lang=js"
export * from "./AccountRecovery.vue?vue&type=script&lang=js"
import style0 from "./AccountRecovery.vue?vue&type=style&index=0&id=bddae8e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddae8e4",
  null
  
)

export default component.exports